import React, { useState } from "react";
import "./Portfolio.scss";
import PortfolioBox from "../../Components/PortfolioBox";
import Uiux from "./Uiux";

function Portfolio() {
  const categoryList = [
    {
      title: "React Js",
      value: "react",
    },
    {
      title: "Angular",
      value: "angular",
    },
    {
      title: "Next js",
      value: "nextjs",
    },
    {
      title: ".Net",
      value: "net",
    },
    {
      title: "Mobile App",
      value: "mobile",
    },
    {
      title: "HTML/CSS",
      value: "html",
    },
    {
      title: "Wordpress",
      value: "wordpress",
    },
    {
      title: "Artificial Intelligence",
      value: "ai",
    },
    // , , , , ,
  ];
  const gallerydata = [
    {
      id: 1,
      image: require("../../Assets/Images/Portfolio/React/fig.jpg"),
      alt: "Vidhan Infotech The Fig",
      cap: "Vidhan Infotech The Fig",
      class: "wl_50",
      name: "The Fig",
      technology: "React Js",
      category: "react",
      link: "https://figk-12.com",
    },
    {
      id: 2,
      image: require("../../Assets/Images/Portfolio/React/eventplanner.jpg"),
      alt: "Vidhan Infotech Conference Planner",
      cap: "Vidhan Infotech Conference Planner",
      class: "wl_50",
      name: "Conference Planner",
      technology: "React Js + .Net",
      category: "react",
      link: "https://fig.events/",
    },
    // {
    //   id: 3,
    //   image: require("../../Assets/Images/Portfolio/ReactNative/online-food-deliver.webp"),
    //   alt: "Vidhan Infotech Online Food Odering Admin",
    //   cap: "Vidhan Infotech Online Food Odering Admin",
    //   class: "wl_50",
    //   name: "Online Food Order",
    //   technology: "React Native",
    //   category: "mobile",
    //   link: "https://play.google.com/store/apps/details?id=order.rashays.app",
    // },
    {
      id: 4,
      image: require("../../Assets/Images/Portfolio/ReactNative/fig_app.png"),
      alt: "Vidhan Infotech The Fig",
      cap: "Vidhan Infotech The Fig",
      class: "wl_50",
      name: " The Fig",
      technology: "React Native",
      category: "mobile",
      link: "https://play.google.com/store/apps/details?id=com.figk12.app",
    },
    {
      id: 5,
      image: require("../../Assets/Images/Portfolio/ReactNative/conferenceApp.png"),
      alt: "Vidhan Infotech Conference App",
      cap: "Vidhan Infotech Conference App",
      class: "wl_50",
      name: "Conference App",
      technology: "Flutter",
      category: "mobile",
      link:
        "https://play.google.com/store/apps/details?id=com.fig.figConferenceApp",
    },
    {
      id: 6,
      image: require("../../Assets/Images/Portfolio/ReactNative/renew360.png"),
      alt: "Vidhan Infotech Renew360 Ai",
      cap: "Vidhan Infotech Renew360 Ai",
      class: "wl_50",
      name: "Renew360 Ai",
      technology: "Flutter",
      category: "mobile",
      link: "https://apps.apple.com/us/app/renew360/id6736639375",
    },
    {
      id: 7,
      image: require("../../Assets/Images/Portfolio/ReactNative/studentIDCard.png"),
      alt: "Vidhan Infotech Student ID Card",
      cap: "Vidhan Infotech Student ID Card",
      class: "wl_50",
      name: "Student ID Card",
      technology: "Flutter",
      category: "mobile",
      link: "https://apps.apple.com/in/app/fig-k-12-student/id6599844808",
    },
    {
      id: 8,
      image: require("../../Assets/Images/Portfolio/Angular/fishingmonk.png"),
      alt: "Vidhan Infotech Fishingmonk",
      cap: "Vidhan Infotech Fishingmonk",
      class: "wl_50",
      name: "Fishingmonk",
      technology: "Angular",
      category: "angular",
      link: "https://shop.fishingmonk.com",
    },
    {
      id: 9,
      image: require("../../Assets/Images/Portfolio/Angular/lala'sKitchen.png"),
      alt: "Vidhan Infotech Lala's Kitchen",
      cap: "Vidhan Infotech Lala's Kitchen",
      class: "wl_50",
      name: "Lala's Kitchen",
      technology: "Angular",
      category: "angular",
      link: "https://www.dev.lalaskitchen.com.au",
    },
    {
      id: 10,
      image: require("../../Assets/Images/Portfolio/NextJs/nawedey.png"),
      alt: "Vidhan Infotech Nawedey",
      cap: "Vidhan Infotech Nawedey",
      class: "wl_50",
      name: "Nawedey",
      technology: "Next Js",
      category: "nextjs",
      link: "http://adminstagging.nawedey.com",
    },
    {
      id: 11,
      image: require("../../Assets/Images/Portfolio/Wordpress/djpepo.png"),
      alt: "Vidhan Infotech DJ Pepe",
      cap: "Vidhan Infotech DJ Pepe",
      class: "wl_50",
      name: "DJ Pepe",
      technology: "Wordpress",
      category: "wordpress",
      link: "https://djpepeofficial.com",
    },
    {
      id: 12,
      image: require("../../Assets/Images/Portfolio/Ai/network360.png"),
      alt: "Vidhan Infotech Renew360 Ai",
      cap: "Vidhan Infotech Renew360 Ai",
      class: "wl_50",
      name: "Renew360 Ai",
      technology: "Artificial Intelligence",
      category: "ai",
      link: "https://www.network360ai.online",
    },
    {
      id: 13,
      image: require("../../Assets/Images/Portfolio/Ai/healthtrack360.png"),
      alt: "Vidhan Infotech HealthTrack360",
      cap: "Vidhan Infotech HealthTrack360",
      class: "wl_50",
      name: "HealthTrack360",
      technology: "Artificial Intelligence",
      category: "ai",
      link: "https://www.healthtrack360ai.online",
    },
    {
      id: 14,
      image: require("../../Assets/Images/Portfolio/Ai/fintech360.png"),
      alt: "Vidhan Infotech FinTech360 AI",
      cap: "Vidhan Infotech FinTech360 AI",
      class: "wl_50",
      name: "FinTech360 AI",
      technology: "Artificial Intelligence",
      category: "ai",
      link: "https://www.fintech360ai.online",
    },
    {
      id: 33,
      image: require("../../Assets/Images/Portfolio/React/artGallery.png"),
      alt: "Art Gallary",
      cap: "Art Gallary",
      class: "wl_50",
      name: "Art Gallary",
      technology: "React Js + .Net",
      category: "react",
      link: "http://artgallary.vidhaninfotech.com/",
    },
    {
      id: 15,
      image: require("../../Assets/Images/Portfolio/React/green.jpg"),
      alt: "Vidhan Infotech Green Onion",
      cap: "Vidhan Infotech Green Onion",
      class: "wl_50",
      name: "Green Onion",
      technology: "React Js + .Net",
      category: "react",
      // link: "http://lifetimek12.com/",
    },
    {
      id: 16,
      image: require("../../Assets/Images/Portfolio/React/barber-app.webp"),
      alt: "Vidhan Infotech Barber App",
      cap: "Vidhan Infotech Barber App",
      name: "Barber App",
      technology: "React Js  + Laravel",
      category: "react",
      // link: "http://barberapp.vidhaninfotech.com",
    },
    {
      id: 17,
      image: require("../../Assets/Images/Portfolio/React/arcade.webp"),
      alt: "Vidhan Infotech Arcade Site",
      cap: "Vidhan Infotech Arcade Site",
      name: "Arcade",
      technology: "React Js",
      category: "react",
      // link: "http://arcade.vidhaninfotech.com/",
    },
    {
      id: 18,
      image: require("../../Assets/Images/Portfolio/React/nautical.webp"),
      alt: "Vidhan Infotech Nautical Narwhals",
      cap: "Vidhan Infotech Nautical Narwhals",
      class: "wr_50",
      name: "Nautical Narwhals",
      technology: "React Js",
      category: "react",
      // link: "http://smartcontract.vidhaninfotech.com/",
    },
    {
      id: 19,
      image: require("../../Assets/Images/Portfolio/ReactNative/HealthTrack.png"),
      alt: "Vidhan Infotech HealthTrack360",
      cap: "Vidhan Infotech HealthTrack360",
      class: "wl_50",
      name: "HealthTrack360",
      technology: "Flutter",
      category: "mobile",
      // link: "https://shop.fishingmonk.com",
    },
    {
      id: 20,
      image: require("../../Assets/Images/Portfolio/ReactNative/emp_app-1.webp"),
      alt: "Vidhan Infotech Employee Time Tracking",
      cap: "Vidhan Infotech Employee Time Tracking",
      class: "wl_50",
      name: "Employee Time Tracking",
      technology: "React Native",
      category: "mobile",
      // link:
      //   "https://play.google.com/store/apps/details?id=com.rashays.myconnectmobile",
    },
    {
      id: 21,
      image: require("../../Assets/Images/Portfolio/ReactNative/barber-app.webp"),
      alt: "Vidhan Infotech Barber App",
      cap: "Vidhan Infotech Barber App",
      class: "wl_50",
      name: "Barber App",
      technology: "React Native",
      category: "mobile",
      // link: "skype:live:.cid.8f1bea8854ffd1c?chat",
    },
    {
      id: 22,
      image: require("../../Assets/Images/Portfolio/ReactNative/datingapp.webp"),
      alt: "Vidhan Infotech Dating App",
      cap: "Vidhan Infotech Dating App",
      class: "wl_50",
      name: "Dating App",
      technology: "React Native",
      category: "mobile",
      // link: "skype:live:.cid.8f1bea8854ffd1c?chat",
    },

    {
      id: 23,
      image: require("../../Assets/Images/Portfolio/ReactNative/instant-grocery.webp"),
      alt: "Vidhan Infotech Grocery App",
      cap: "Vidhan Infotech Grocery App",
      class: "wl_50",
      name: "Grocery App",
      technology: "React Native",
      category: "mobile",
      // link: "skype:live:.cid.8f1bea8854ffd1c?chat",
    },
    {
      id: 24,
      image: require("../../Assets/Images/Portfolio/ReactNative/cashcow.webp"),
      alt: "Vidhan Infotech Cash Cow App",
      cap: "Vidhan Infotech Cash Cow App",
      class: "wl_50",
      name: "Cash Cow",
      technology: "Flutter",
      category: "mobile",
      // link: "skype:live:.cid.8f1bea8854ffd1c?chat",
    },
    {
      id: 25,
      image: require("../../Assets/Images/Portfolio/ReactNative/swanmobile.webp"),
      alt: "Vidhan Infotech Swan Scoring App",
      cap: "Vidhan Infotech Swan Scoring App",
      class: "wl_50",
      name: "Swan Scoring",
      technology: "React Native",
      category: "mobile",
      // link:
      //   "https://play.google.com/store/apps/details?id=com.swanscoring.swan",
    },
    {
      id: 26,
      image: require("../../Assets/Images/Portfolio/ReactNative/online-food-service-img.webp"),
      alt: "Vidhan Infotech Food Ordering App",
      cap: "Vidhan Infotech Food Ordering App",
      name: "Food Ordering App",
      technology: "React Native",
      category: "mobile",
      // link: "https://play.google.com/store/apps/details?id=order.rashays.app",
    },
    {
      id: 27,
      image: require("../../Assets/Images/Portfolio/Net/tekvision.webp"),
      alt: "Vidhan Infotech Tek Visions",
      cap: "Vidhan Infotech Tek Visions",
      name: "Tek Visions",
      technology: ".Net",
      category: "net",
      // link: "https://teksolution.vidhaninfotech.com/",
    },
    {
      id: 28,
      image: require("../../Assets/Images/Portfolio/Net/online-restuarant-img-scaled.webp"),
      alt: "Vidhan Infotech Online Restuarant Management Sytem",
      cap: "Vidhan Infotech Online Restuarant Management Sytem",
      name: "Online Restuarant Management Sytem",
      technology: ".Net",
      category: "net",
      // link: "skype:live:.cid.8f1bea8854ffd1c?chat",
    },
    {
      id: 29,
      image: require("../../Assets/Images/Portfolio/Net/emp_system-img.webp"),
      alt: "Vidhan Infotech Employee Monitoring System",
      cap: "Vidhan Infotech Employee Monitoring System",
      name: "Employee Monitoring System",
      technology: ".Net",
      category: "net",
      // link: "http://myconnect.vidhaninfotech.com/",
    },
    {
      id: 30,
      image: require("../../Assets/Images/Portfolio/Net/Imsportfolio-min-new-scaled-1.webp"),
      alt: "Vidhan Infotech Online Education management system",
      cap: "Vidhan Infotech Online Education management system",
      name: "Online Education management system",
      technology: ".Net",
      category: "net",
      // link: "skype:live:.cid.8f1bea8854ffd1c?chat",
    },
    {
      id: 31,
      image: require("../../Assets/Images/Portfolio/Net/camping.jpg"),
      alt: "Vidhan Infotech Campaing",
      cap: "Vidhan Infotech Campaing",
      class: "wl_50",
      name: " Campaing",
      technology: ".Net",
      category: "net",
      // link: "http://campaign.vidhaninfotech.com/Login/DoLogin",
    },
    {
      id: 32,
      image: require("../../Assets/Images/Portfolio/html/prarns.webp"),
      alt: "Vidhan Infotech Prans impex",
      cap: "Vidhan Infotech Prans impex",
      class: "wl_50",
      name: "Prans impex",
      technology: "HTML + CSS",
      category: "html",
      // link: "skype:live:.cid.8f1bea8854ffd1c?chat",
    },
    {
      id: 33,
      image: require("../../Assets/Images/Portfolio/Wordpress/Final_Low_Deposit_Home.png"),
      alt: "Vidhan Infotech Low Deposit Homes",
      cap: "Vidhan Infotech Low Deposit Homes",
      class: "wl_50",
      name: "Low Deposit Homes",
      technology: "Wordpress",
      category: "wordpress",
      link: "https://lowdeposithomes.com.au/",
    },
    {
      id: 34,
      image: require("../../Assets/Images/Portfolio/Wordpress/news_continous.png"),
      alt: "Vidhan Infotech News Continuous",
      cap: "Vidhan Infotech News Continuous",
      class: "wl_50",
      name: "News Continuous",
      technology: "Wordpress",
      category: "wordpress",
      link: "https://www.newscontinuous.com/",
    },
    {
      id: 35,
      image: require("../../Assets/Images/Portfolio/Wordpress/Accumax.png"),
      alt: "Vidhan Infotech Accumax",
      cap: "Vidhan Infotech Accumax",
      class: "wl_50",
      name: "Accumax",
      technology: "Wordpress",
      category: "wordpress",
      link: "https://www.accumaxlab.com/",
    },
    {
      id: 36,
      image: require("../../Assets/Images/Portfolio/ReactNative/Lala_Kitchen.jfif"),
      alt: "Vidhan Infotech Lala's Kitchen App",
      cap: "Vidhan Infotech Lala's Kitchen App",
      name: "Lala's Kitchen",

      technology: "React Native",
      category: "mobile",
      // link: "https://play.google.com/store/apps/details?id=order.rashays.app",
    },
    {
      id: 36,
      image: require("../../Assets/Images/Portfolio/ReactNative/stackable.png"),
      alt: "Vidhan Infotech Stackable App",
      cap: "Vidhan Infotech Stackable App",
      name: "Stackable",
      technology: "React Native",
      category: "mobile",
      // link: "https://play.google.com/store/apps/details?id=order.rashays.app",
    },
    {
      id: 36,
      image: require("../../Assets/Images/Portfolio/ReactNative/nawedey.png"),
      alt: "Vidhan Infotech Nawedey App",
      cap: "Vidhan Infotech Nawedey App",
      name: "Nawedey",
      technology: "React Native",
      category: "mobile",
      link: "https://apps.apple.com/in/app/nawedey/id6462760140",
    },
    {
      id: 37,
      image: require("../../Assets/Images/Portfolio/html/mummysHairOil.png"),
      alt: "Vidhan Infotech Mummy's Hair Oil",
      cap: "Vidhan Infotech Mummy's Hair Oil",
      class: "wl_50",
      name: "Mummy's Hair Oil",
      technology: "HTML + CSS",
      category: "html",
      // link: "skype:live:.cid.8f1bea8854ffd1c?chat",
    },
    {
      id: 38,
      image: require("../../Assets/Images/Portfolio/React/local-stranger-chat.png"),
      alt: "Vidhan Infotech Local Stranger Chat",
      cap: "Vidhan Infotech Local Stranger Chat",
      class: "wr_50",
      name: "Local Stranger Chat",
      technology: "React Js + .Net",
      category: "react",
      // link: "http://smartcontract.vidhaninfotech.com/",
    },
    // {
    //   id: 38,
    //   image: require("../../Assets/Images/Portfolio/html/SnelServices.png"),
    //   alt: "Vidhan Infotech Snel Services",
    //   cap: "Vidhan Infotech Snel Services",
    //   class: "wl_50",
    //   name: "Snel Services",
    //   technology: "HTML + CSS",
    //   category: "html",
    //   // link: "skype:live:.cid.8f1bea8854ffd1c?chat",
    // },
  ];

  const [item, setItem] = useState(gallerydata);
  const [activButton, setActivButton] = useState("");

  const Filteritem = (filtItem) => {
    const filtereditem = gallerydata.filter((Curritem) => {
      return Curritem.category === filtItem;
    });
    setItem(filtereditem);
    setActivButton(filtItem);
  };
  const Filterall = () => {
    setItem(gallerydata);
    setActivButton("");
  };

  return (
    <>
      <section className="work">
        <div className="container">
          <div className="title mb-5">
            {/* <h4 className="line_title">Services</h4> */}
            <h1>
              Our <span>Amazing Works</span>
            </h1>
            <p>
              We offer a wide range of software development services that
              provide industry specific solutions that align people, processes
              and systems to scale and grow your business to pro level.
            </p>
          </div>
          <Uiux />
        </div>
      </section>
      <section className="portfolio">
        <div className="container">
          <div className="row mb-4">
            <div className="col-lg-12">
              <div className="title mb-lg-5">
                <h4 className="line_title">Portfolio</h4>
                <h2>
                  Our <span>Portfolio</span>
                </h2>
                <p>
                  We offer a wide range of software development services that
                  provide industry specific solutions that align people,
                  processes and systems to scale and grow your business to pro
                  level.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="portfolio_filter_button">
                <button
                  className={activButton === "" ? "active" : ""}
                  onClick={() => Filterall()}
                >
                  All
                </button>
                {categoryList?.map((item, i) => (
                  <button
                    key={i}
                    className={activButton === item.value ? "active" : ""}
                    onClick={() => Filteritem(item.value)}
                  >
                    {item.title}
                  </button>
                ))}
              </div>
              <div className="portfolio_row">
                {item.map((Projects, i) => (
                  <PortfolioBox
                    key={i}
                    className={Projects.class}
                    Image={Projects.image}
                    alt={Projects.alt}
                    cap={Projects.cap}
                    Name={Projects.name}
                    Technology={Projects.technology}
                    Link={Projects.link}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default React.memo(Portfolio);
